import React, { useEffect, useRef, useState } from 'react'
import ModalComponent from '../../../core/common/modal/ModalComponent';
import * as Yup from "yup";
import { useFormik } from "formik";
import { useCreateUserMutation, useGetCreateUserLookupQuery } from '../../../services/EndPointsApis';
import { InputMask } from '@react-input/mask';
import Select, { StylesConfig } from "react-select";
// import Select from 'react-dropdown-select';
import TextField from '../../../core/common/textFields/TextField';
import { svgIcons } from '../../../style/fonts/SvgIcons';
import { setUser } from '../../../Features/authslice';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { all_routes } from '../../router/all_routes';
import { LoadingComponent } from '../../../core/common/loadingComponent/LoadingComponent';
import { removeImage, setImage } from '../../../Features/commonSlice';
import { RootState } from '../../../store';
import axios from 'axios';

type Props = {
  show: boolean
  handleClose: () => void
  data?: any
  viewOnly?: any
  isEdit?: any
  isRowClicked?: any
  refetch?: any

}
// interface TeamOption {
//   map(arg0: (option: any) => any): unknown;
//   label: any;
//   value: any;
// }
type TeamOption = {
  label: number;
  value: string;
};

const loginSchema = Yup.object().shape({
  firstName: Yup.string()
    .required("FirstName is required"),
  lastName: Yup.string()
    .required("lastName is required"),
  email: Yup.string()
    .required("Email is required"),
  cellPhone: Yup.string()
    .required("contact is required"),
  businessUnit: Yup.object().shape({
    id: Yup.number().required('Business Unit ID is required'),
    title: Yup.string().required('Business Unit title is required'),
  }),
  team: Yup.array().of(
    Yup.object().shape({
      id: Yup.number().required('Team ID is required'),
      name: Yup.string().required('Team name is required'),
    })
  ),
  roles: Yup.array().of(
    Yup.object().shape({
      roleID: Yup.number().required('Role ID is required'),
      roleName: Yup.string().required('Role name is required'),
    })
  ),
  // roles: Yup.object().shape({
  //   roleID: Yup.number().required('Role ID is required'),
  //   name: Yup.string().required('Role name is required'),
  // }),
  addressLine1: Yup.string()
    .required("address is required"),
  state: Yup.string()
    .required('state is required'),
  city: Yup.string()
    .required("city is required"),
  postalCode: Yup.string()
    .required("zipcode is required"),
});
const AddUpdateUserModal = ({ show, handleClose, data, viewOnly, isEdit, isRowClicked, refetch }: Props) => {
  const [createUser, { data: userData, isError, error, isSuccess, isLoading }] = useCreateUserMutation();
  const { data: usersLookup } = useGetCreateUserLookupQuery('');//lookups users
  const [updateId, setUpdateId] = useState(0);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const imageUrl = useSelector((state: RootState) => state.common?.imageUrl);

  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const initialValues = {
    toggleStatus: false,
    userAccountId: 0,
    adB2CExternalUserId: '',
    passwordResetToken: '',
    passwordResetRequestDate: '',
    createDT: '',
    lastEditDT: '',
    managerId: 0,
    email: '',
    firstName: '',
    lastName: '',
    cellPhone: '',
    password: '',
    businessPhone: '',
    businessExt: '',
    state: '',
    postalCode: '',
    status: '',
    imageUrl: '',
    addressLine1: '',
    addressLine2: '',
    lastLoginDt: '',
    timeZone: '',
    active: true,
    employeeId: '',
    businessUnit: {
      id: 0,
      title: ''
    },
    country: {
      id: 1,
      title: 'USA'
    },
    team: [
      {
        id: 0,
        name: ''
      }
    ],
    city: '',
    orgId: 0,
    // roles: {
    //   roleID: 0,
    //   name: '',
    //   fk_OrganizationID: 0,
    //   active: true
    // },
    roles: [
      {
        roleID: 0,
        roleName: '',
      }
    ],
    file: '',
    countryName: 'USA'
  };


  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append('file', values.file);
      formData.append('imageUrl', values?.imageUrl);
      if (updateId) {
        createUser(values)
      } else {
        createUser(values)
      }
    },
  });
  const { resetForm } = formik;


  const handleRemoveImage = () => {
    dispatch(removeImage());
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  useEffect(() => {
    if (data && Object.keys(data).length > 0) {
      setUpdateId(data?.userAccountId);
      formik.setValues({ ...data });
    } else {
      setUpdateId(0);
      // resetForm();
    }
  }, [data, updateId]);

  useEffect(() => {
    if (!isEdit && isSuccess) {
      toast.success(userData?.message);
      handleClose();
      resetForm()
      refetch()
      // navigate(route.manageusers);
    }
    if (isEdit && isSuccess) {
      toast.success('User Updated Successfully');
      handleClose();
      refetch()
    }
  }, [isSuccess]);

  useEffect(() => {
    if (isError && error) {
      let errorMessage: string = 'Something went wrong';

      if ('data' in error && error.data && typeof error.data === 'object' && 'message' in error.data) {
        errorMessage = (error.data as { message: string }).message;
      }
      toast.error(errorMessage);
    }
  },
    [isError, error]);

  const selectValues = formik.values?.team
    ? formik?.values?.team
      ?.filter((teams: { id: number; name: string }) => teams?.id !== 0 && teams?.name !== '')
      ?.map((teams: { id: number; name: string }) => ({
        value: teams?.id,
        label: teams?.name,
      }))
    : [];

  const selectValuesRoles = Array.isArray(formik.values?.roles)
    ? formik.values.roles
      .filter((role: { roleID: number; roleName: string }) => role.roleID !== 0 && role.roleName !== '')
      .map((role) => ({
        value: role.roleID,
        label: role.roleName,
      }))
    : [];


  // formik.values?.team?.id?.length > 0
  // ? formik.values?.teams?.id.map((id: number, index: number) => ({
  //   value: id,
  //   label: formik.values?.teams?.name[index] || '',
  // }))
  // : []

  const handleImageChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const imageUrl = URL.createObjectURL(file);
    dispatch(setImage(imageUrl));

    // Set Formik values for local preview
    formik.setFieldValue('imageUrl', imageUrl);
    formik.setFieldValue('file', file);

    // Prepare FormData
    const formData = new FormData();
    formData.append('file', file);
    try {
      // Send the image via axios
      const response = await axios.post(
        'https://afdapidev.azurewebsites.net/api/Account/UploadProfilePicture',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data', // Important for file uploads
          },
        }
      );

      console.log('Upload successful:', response.data); // Check response data

      // Update state and Formik with the server response
      dispatch(setImage(response.data.result)); // Update the redux state with the image URL
      formik.setFieldValue('imageUrl', response.data.result); // Set Formik field with the image URL
    } catch (error) {
      console.error('Error uploading the image:', error);
    }
  };

  const optionsCountry = [
    { value: 1, label: "Choose" },
    { value: 2, label: "USA" },
  ];
  const handleChangestatus = (id: any) => {
    formik.setFieldValue('status', id);

  };
  useEffect(() => {
    if (!show && !isEdit && !viewOnly) {
      resetForm();
    }
    if (isRowClicked && !isEdit && !viewOnly) {
      resetForm();
    }
  }, [show, isEdit,]);


  const customStyles: StylesConfig = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
      color: state.isFocused ? "#fff" : "#000",
      "&:hover": {
        backgroundColor: "rgba(177, 31, 40, 1)",
      },
    }),
  };

  const handleChange = (newValue: any) => {
    const updatedValues: TeamOption[] = newValue.map((option: { value: any; label: any }) => ({
      id: option.value,
      name: option.label
    }));

    formik.setFieldValue('team', updatedValues);

  };
  const handleChangeRoles = (newValue: any) => {
    const updatedValues: TeamOption[] = newValue.map((option: { value: any; label: any }) => ({
      roleID: option.value,
      roleName: option.label
    }));

    formik.setFieldValue('roles', updatedValues);

  };
  return (
    <ModalComponent
      buttonText=""
      modalTitle={viewOnly ? "User Details" : updateId ? "Update User" : "Add User"}
      onClose={handleClose}
      onSave={formik.handleSubmit}
      isVisible={show}
      cancelButton="Cancel"
      saveButton={updateId ? "Update" : "Save"}
      className="modal-xl"
      isLoading={isLoading ? 'loading....' : ''}
      viewOnly={viewOnly}
    >
      <>
        <div className="container">
          <form onSubmit={formik.handleSubmit}>
            <div className="row">
              <div className="col-md-4">
                <div className="profile-pic-upload">
                  <div className="profile-pic">
                    {/* <span className="position-absolute top-0 start-100 translate-middle pointer" onClick={handleRemoveImage}>
                      {svgIcons.DeleteIcon}
                    </span> */}
                    <img
                      src={formik.values?.imageUrl || '/assets/img/profiles/default-upload-img.jpg'}
                      alt="img"
                      className="preview1"
                    />
                  </div>
                  {!viewOnly &&
                    <div className="upload-content">
                      <div className="upload-btn">
                        <input
                          type="file"
                          accept=".png, .jpg, .jpeg"
                          onChange={handleImageChange}
                          ref={fileInputRef}
                          disabled={viewOnly}
                        />
                        <span>
                          <i className="ti ti-upload" />
                          Upload Image
                        </span>
                      </div>
                      <p>JPG, GIF or PNG. Max size of 800K</p>
                    </div>
                  }
                </div>
              </div>
              <div className="col-md-4">
                <div className="input-label">
                  <TextField
                    label="First Name"
                    required
                    type="text"
                    disabled={viewOnly}
                    {...formik.getFieldProps("firstName")}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^[A-Za-z]*$/.test(value)) {
                        formik.setFieldValue("firstName", value);
                      }
                    }}
                  />
                </div>
                {formik.touched.firstName && formik.errors.firstName && (
                  <div className="error">{formik.errors.firstName}</div>
                )}
              </div>
              <div className="col-md-4">
                <div className="input-label">
                  <TextField
                    label="Last Name"
                    required
                    type="text"
                    disabled={viewOnly}
                    {...formik.getFieldProps("lastName")}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^[A-Za-z]*$/.test(value)) {
                        formik.setFieldValue("lastName", value);
                      }
                    }}
                  />
                </div>
                {formik.touched.lastName && formik.errors.lastName && (
                  <div className="error">{formik.errors.lastName}</div>
                )}
              </div>
              <div className="col-md-6">
                <TextField
                  label="Email"
                  required
                  type="text"
                  disabled={viewOnly}
                  {...formik.getFieldProps("email")}
                />
                {formik.touched.email && formik.errors.email && (
                  <div className="error">{formik.errors.email}</div>
                )}
              </div>
              <div className="col-md-6">
                <label className="input-label">
                  Phone No. <span className="text-danger">*</span>
                </label>

                <InputMask mask="(___) ___-____"
                  replacement={{ _: /\d/ }}
                  className="form-control"
                  {...formik.getFieldProps("cellPhone")}
                  disabled={viewOnly}
                />
                {formik.touched.cellPhone && formik.errors.cellPhone && (
                  <div className="error">{formik.errors.cellPhone}</div>
                )}
              </div>
              <div className="col-md-4">
                <div className="form-wrap">
                  <label className="input-label">
                    Business Unit <span className="text-danger">*</span>
                  </label>
                  <Select
                    styles={customStyles}
                    className="select"
                    options={usersLookup?.result?.businessUnits?.map((option: any) => ({
                      label: option?.name,
                      value: option?.id
                    }))}
                    value={
                      formik.values?.businessUnit?.id
                        ? {
                          value: formik.values?.businessUnit?.id,
                          label: formik.values?.businessUnit?.title || '',
                        }
                        : []
                    }
                    isDisabled={viewOnly}
                    onChange={(selectedOption: any) => {
                      formik.setFieldValue('businessUnit.id', selectedOption.value);
                      formik.setFieldValue('businessUnit.title', selectedOption.label);
                    }}
                  />
                </div>
                {formik.touched.businessUnit && formik.errors.businessUnit && (
                  <div className="error">{formik.errors.businessUnit?.title}</div>
                )}
              </div>
              <div className="col-md-4">
                <div className="form-wrap">
                  <label className="input-label">
                    Teams <span className="text-danger">*</span>
                  </label>
                  <Select
                    isMulti={true}
                    styles={customStyles}
                    className="select multi-select"
                    options={usersLookup?.result?.teamList?.map((option: any) => ({
                      label: option?.name,
                      value: option?.id
                    })) || []}
                    value={
                      selectValues
                    }
                    isDisabled={viewOnly}
                    onChange={(newValue: any) => handleChange(newValue)}
                  />
                </div>
                {formik.touched.team?.map((teamTouched, index) => {
                  const errorAtIndex = formik.errors.team?.[index];
                  if (
                    teamTouched.name &&
                    errorAtIndex &&
                    typeof errorAtIndex === 'object' &&
                    'name' in errorAtIndex
                  ) {
                    return (
                      <div className="error" key={index}>
                        {errorAtIndex.name}
                      </div>
                    );
                  }

                  return null;
                })}

              </div>
              <div className="col-md-4">
                <div className="form-wrap">
                  <label className="input-label">
                    Roles <span className="text-danger">*</span>
                  </label>
                  <Select
                    isMulti={true}
                    styles={customStyles}
                    className="select multi-select"
                    options={usersLookup?.result?.roles?.map((option: any) => {
                      return {
                        label: option?.name,
                        value: option?.id
                      }
                    }) || []}
                    value={
                      selectValuesRoles
                    }
                    isDisabled={viewOnly}
                    onChange={(newValue: any) => handleChangeRoles(newValue)}
                  />
                </div>
                {formik.touched.roles?.map((rolesTouched: any, index: any) => {
                  const errorAtIndex = formik.errors.team?.[index];
                  if (
                    rolesTouched.name &&
                    errorAtIndex &&
                    typeof errorAtIndex === 'object' &&
                    'name' in errorAtIndex
                  ) {
                    return (
                      <div className="error" key={index}>
                        {errorAtIndex.name}
                      </div>
                    );
                  }

                  return null;
                })}

              </div>
              {/* <div className="col-md-4">
                <div className="form-wrap">
                  <label className="input-label">
                    Role <span className="text-danger">*</span>
                  </label>
                  <Select
                    styles={customStyles}
                    className="select"
                    options={usersLookup?.result?.roles?.map((option: any) => ({
                      label: option?.name,
                      value: option?.id
                    }))}
                    value={
                      formik.values?.roles?.roleID
                        ? {
                          value: formik.values?.roles?.roleID,
                          label: formik.values?.roles?.name || '',
                        }
                        : null
                    }
                    isDisabled={viewOnly}
                    onChange={(selectedOption: any) => {
                      formik.setFieldValue('roles.roleID', selectedOption.value);
                      formik.setFieldValue('roles.name', selectedOption.label);
                    }}
                  />
                </div>
                {formik.touched.roles && formik.errors.roles && (
                  <div className="error">{formik.errors.roles?.name}</div>
                )}
              </div> */}
              <div className="col-md-6">
                <div className="form-wrap">
                  <label className="input-label">Address Line1 <span className="text-danger">*</span></label>
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control"
                      disabled={viewOnly}
                      {...formik.getFieldProps("addressLine1")}
                    />
                  </div>
                  {formik.touched.addressLine1 && formik.errors.addressLine1 && (
                    <div className="error">{formik.errors.addressLine1}</div>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-wrap">
                  <label className="input-label">Address Line2</label>
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control"
                      disabled={viewOnly}
                      {...formik.getFieldProps("addressLine2")}
                    />
                  </div>
                  {formik.touched.addressLine2 && formik.errors.addressLine2 && (
                    <div className="error">{formik.errors.addressLine2}</div>
                  )}
                </div>
              </div>
              <div className="col-md-3">
                <TextField
                  label="State/Region"
                  required
                  type="text"
                  disabled={viewOnly}
                  {...formik.getFieldProps("state")}
                />
                {formik.touched.state && formik.errors.state && (
                  <div className="error">{formik.errors.state}</div>
                )}
              </div>
              <div className="col-md-3">
                <TextField
                  label="City"
                  required
                  type="text"
                  disabled={viewOnly}
                  {...formik.getFieldProps("city")}
                />
                {formik.touched.city && formik.errors.city && (
                  <div className="error">{formik.errors.city}</div>
                )}
              </div>
              <div className="col-md-3">
                <label className='input-label'>Zipcode <span className='text-danger'>*</span></label>
                <InputMask mask="_____-____"
                  replacement={{ _: /[a-zA-Z0-9]/ }}
                  className="form-control"
                  {...formik.getFieldProps("postalCode")}
                  disabled={viewOnly}
                />
                {formik.touched.postalCode && formik.errors.postalCode && (
                  <div className="error">{formik.errors.postalCode}</div>
                )}
              </div>
              <div className="col-md-3">
                <TextField
                  label="Country"
                  type="text"
                  required
                  disabled={viewOnly}
                  {...formik.getFieldProps("countryName")}
                />
                {formik.touched.country && formik.errors.country && (
                  <div className="error">{formik.errors.country?.id}</div>
                )}
              </div>
              <div className="col-md-6 d-flex align-items-center">
                <div className="radio-wrap">
                  <label className="input-label">Status</label>
                  <div className="d-flex flex-wrap">
                    <div className="radio-btn">
                      <input
                        type="radio"
                        className="status-radio"
                        id="active"
                        name="active"
                        value="true"
                        disabled={viewOnly}
                        checked={formik.values.active === true}
                        onChange={() => formik.setFieldValue('active', true)}
                      />
                      <label htmlFor="active">Active</label>
                    </div>
                    <div className="radio-btn">
                      <input
                        type="radio"
                        className="status-radio"
                        id="inactive"
                        name="active"
                        value="false"
                        disabled={viewOnly}
                        checked={formik.values.active === false}
                        onChange={() => formik.setFieldValue('active', false)}
                      />
                      <label htmlFor="inactive">Inactive</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </>

    </ModalComponent>
  )
}

export default AddUpdateUserModal